import { createStore } from '../_core/createStore';
import { lazyDependency } from '../_core/lazyDependency';
import { pickState } from '../_core/pickState';
import useApiStore from '../apiStore/useApiStore';
import useLeadChannelStore from '../leadChannelStore/useLeadChannelStore';
import useParameterStore from '../parameterStore/useParameterStore';
import {
  applicationUpdateStore,
  keysToPersist,
} from './applicationUpdateStore';

const useApplicationUpdateStore = createStore({
  creator: applicationUpdateStore({
    useApiStore: lazyDependency(() => useApiStore),
    useLeadChannelStore: lazyDependency(() => useLeadChannelStore),
    useParameterStore: lazyDependency(() => useParameterStore),
  }),
  id: 'applicationUpdate',
  middlewares: {
    devtools: true,
    persist: {
      partialize(state) {
        return pickState(state, keysToPersist);
      },
    },
  },
});

export default useApplicationUpdateStore;
